import { useCallback, useRef, useState } from "react";

// Returns [setRef, width] — attach setRef to the chart wrapper and only render a
// fixed-size Recharts chart once width > 0. This avoids Recharts'
// ResponsiveContainer logging "width(-1)/height(-1)" on its first render.
// Uses a callback ref (not useRef) so the ResizeObserver is set up the moment
// the wrapper attaches to the DOM — even when it renders after data loads.
export function useMeasuredWidth() {
  const [width, setWidth] = useState(0);
  const roRef = useRef(null);
  const setRef = useCallback((node) => {
    if (roRef.current) {
      roRef.current.disconnect();
      roRef.current = null;
    }
    if (node) {
      const update = () => setWidth(node.clientWidth || 0);
      update();
      const ro = new ResizeObserver(update);
      ro.observe(node);
      roRef.current = ro;
    }
  }, []);
  return [setRef, width];
}
